import React, { useState } from "react";
import styled from "styled-components";

//ck
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import docIcon from "../../../assets/icons/doc-icon.svg";
import jpgIcon from "../../../assets/icons/jpg-icon.svg";
import pdfIcon from "../../../assets/icons/pdf-icon.svg";
import pngIcon from "../../../assets/icons/png-icon.svg";
import pptIcon from "../../../assets/icons/ppt-icon.svg";
import othIcon from "../../../assets/icons/oth.png";
import closeIcon from "../../../assets/icons/close.png";
import xlsxIcon from "../../../assets/icons/xlsx-icon.svg";
import mp4Icon from "../../../assets/icons/mp4-icon.svg";

const getFileIcon = (extension) => {
  if (!extension) return othIcon;
  extension = extension.toLowerCase();

  switch (extension) {
    case "pdf":
      return pdfIcon;
    case "ppt":
    case "pptx":
      return pptIcon;
      case "doc":
      return docIcon;
      case "docx":
      return docIcon;
    case "word":
      return docIcon;
    case "jpg":
      return jpgIcon;
    case "png":
      return pngIcon;
    case "gif":
      return pngIcon;
    case "webp":
      return pngIcon;
    case "svg":
      return pngIcon;
    case "image":
      return jpgIcon;
    case "xlsx":
      return xlsxIcon;
    case "mp4":
      return mp4Icon;
    case "video":
      return mp4Icon;
    default:
      return othIcon;
  }
};

const normalizeFileType = (extension) => {
  if (!extension) return "";
  const lowerExt = extension.toLowerCase();

  // Group related file types
  if (["ppt", "pptx"].includes(lowerExt)) return ".ppt,.pptx";
  if (["doc", "docx", "word"].includes(lowerExt)) return ".doc,.docx";
  if (["jpg", "jpeg"].includes(lowerExt)) return ".jpg,.jpeg";

  return "." + lowerExt;
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export default function AssignmentQnCard({
  data,
  selectedViewmore,
  setSelectedViewmore,
  index,
  // New props for question-wise file handling
  isQuestionWise = false,
  hasFile = false,
  fileData = null,
  onFileUpload,
  onFileRemove,
}) {


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && onFileUpload) {
    	onFileUpload(file);
    }
  };

  const handleFileRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onFileRemove) {
      onFileRemove();
    }
  };

  // Show file preview if uploaded
  const renderFilePreview = (isSubmittedFile = false) => {
    return (
      <UploadedFilePreview
        target="_blank" 
		rel="noopener noreferrer"
		href={(!isSubmittedFile && fileData?.file) ? URL.createObjectURL(fileData.file) : isSubmittedFile ? data.latest_file : "#"}
      >
		{isSubmittedFile ?
		<FileIcon src={getFileIcon(data.latest_file_type)} />:
		<FileIcon src={getFileIcon(fileData.fileName?.split(".").pop())} />	
		}
		{isSubmittedFile ? <>
			<FileDetails>
          <UploadedFileName isSubmittedFile={isSubmittedFile}>{data.latest_file_name}</UploadedFileName>
        </FileDetails>
		</>:
		  <>
		  <FileDetails>
          <UploadedFileName>{fileData.fileName}</UploadedFileName>
          <FileSize>{formatFileSize(fileData.fileSize)}</FileSize>
        </FileDetails>
        <RemoveFileButton onClick={handleFileRemove} title="Remove file">
          <img
            src={closeIcon}
            alt="remove"
            style={{ width: "12px", height: "12px" }}
          />
        </RemoveFileButton>	  
		  </>}
        
        
      </UploadedFilePreview>
    );
  };

  return (
    <AssignmentCardDiv>
      <TopDiv>
        <div style={{ display: "flex" }}>
          <AssignmentTitle>
            <QNo>Q.{index + 1}</QNo>
            {data.question}
          </AssignmentTitle>
		  

		  {isQuestionWise && data.latest_file &&   (
            <UploadContainer>
              { renderFilePreview(true)}
            </UploadContainer>
          )}

          {/* Show upload button only for question-wise assignments */}
          {isQuestionWise && !["approved","pending"].includes(data.qstn_wise_submission_status)  && (
            <UploadContainer>
              {hasFile ? (
                // Show file preview when file is uploaded
                renderFilePreview()
              ) : (
                // Show upload button when no file is uploaded
                <UploadButton hasFile={hasFile}>
                  <HiddenInput
                    type="file"
                    accept={normalizeFileType(data.file_type_name)}
                    onChange={handleFileChange}
                  />
                  <FileIcon src={getFileIcon(data.file_type_name)} />
                  <FileInfo>
                    <FileName>Upload file</FileName>
                  </FileInfo>
                </UploadButton>
              )}

              {/* Show error if any */}
              {fileData?.error && <ErrorMessage>{fileData.error}</ErrorMessage>}
            </UploadContainer>
          )}
        </div>
      </TopDiv>

      <MiddleDiv>
        <MiddleLeft>
			{data.mark>0 && 
			<MarksText>
            Marks: <Mark>{data.mark}</Mark>
          </MarksText>
		  }      
          <MarksText>
            Minimum Words: <Mark>{data.min_words}</Mark>
          </MarksText>
          {data.max_words ? (
            <MarksText>
              Maximum Words: <Mark>{data.max_words}</Mark>
            </MarksText>
          ) : null}
          {isQuestionWise && data.file_type_name && (
            <MarksText>
              File Type: <Mark>{data.file_type_name}</Mark>
            </MarksText>
          )}
        </MiddleLeft>
        {data.description && (
          <ViewMoreDiv>
            <ViewMore
              onClick={() => {
                if (selectedViewmore) {
                  setSelectedViewmore("");
                } else {
                  setSelectedViewmore(data.id);
                }
              }}
            >
              {selectedViewmore === data.id ? "View less..." : "View more..."}
            </ViewMore>
          </ViewMoreDiv>
        )}
      </MiddleDiv>

      {selectedViewmore === data.id && data.description && (
        <DescriptionDiv>
          <CkDiv className="ckeditor-custom">
            <CKEditor
              config={{
                toolbar: [],
                shouldNotGroupWhenFull: true,
              }}
              editor={ClassicEditor}
              data={data?.description}
              onReady={(editor) => {}}
              onBlur={(event, editor) => {}}
              onFocus={(event, editor) => {}}
              onChange={(event, editor) => {}}
            />
          </CkDiv>
        </DescriptionDiv>
      )}
    </AssignmentCardDiv>
  );
}

const AssignmentCardDiv = styled.div`
  width: 100%;
  padding: 15px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
  transition: 0.3s;
`;

const TopDiv = styled.div`
  margin-bottom: 20px;
  user-select: text;
`;

const QNo = styled.span`
  margin-right: 8px;
  font-size: 1rem;
`;

const AssignmentTitle = styled.h6`
  flex: 1;
  font-size: 1rem;
  font-weight: 500;
  color: #010101;
  line-height: 1.5em;
  user-select: text !important;
`;

const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
`;

const UploadButton = styled.label`
  width: 151px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11.68px;
  background: ${(props) => (props.hasFile ? "#E8F5E8" : "#F5EFFF")};
  margin-left: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: ${(props) =>
    props.hasFile ? "1px solid #4CAF50" : "1px solid transparent"};

  &:hover {
    background: ${(props) => (props.hasFile ? "#D4F4D4" : "#E8DDFF")};
    // transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

const HiddenInput = styled.input`
  display: none;
`;

const FileIcon = styled.img`
  width: 15px;
  height: 15px;
  object-fit: contain;
  margin-right: 8px;
`;

const FileInfo = styled.div``;

const FileName = styled.div`
  font-weight: 400;
  font-style: Regular;
  font-size: 15.43px;
  line-height: 35.03px;
  letter-spacing: 0%;
`;

const UploadedFilePreview = styled.a`
  display: flex;
  text-decoration:none;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px 12px;
  margin-left: 10px;
  min-width: 200px;
  // position: relative;
  height:44px;
`;

const FileDetails = styled.div`
  flex: 1;
  margin-left: 8px;
`;

const UploadedFileName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${(props)=> !props.isSubmittedFile ? "120px":"145px"};
  
`;

const FileSize = styled.div`
  font-size: 11px;
  color: #666;
`;

const RemoveFileButton = styled.button`
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #ff3742;
    // transform: scale(1.1);
  }
`;

const ErrorMessage = styled.div`
  color: #ff4757;
  font-size: 12px;
  margin-left: 10px;
  padding: 4px 8px;
  background: #ffe6e6;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
`;

const MiddleDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MiddleLeft = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`;

const ViewMoreDiv = styled.div``;

const ViewMore = styled.h4`
  color: #927af6;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #7c63f0;
  }
`;

const DescriptionDiv = styled.div`
  margin-top: 10px;
`;

const CkDiv = styled.div`
  &.ckeditor-custom p {
    color: #000;
  }
`;

const MarksText = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #9d9d9d;

  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
`;

const Mark = styled.span`
  display: inline-block;
  font-size: 0.88rem;
  color: #404040;
  margin-left: 6px;
  font-weight: 500;
`;

const BottomDiv = styled.div`
  margin-top: 15px;
`;

const Hint = styled.p`
  color: #9d9d9d;
  font-size: 0.9rem;
`;

const HintText = styled.span`
  color: #404040;
  font-size: 00.9rem;
`;
